import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';

const severityConfig = {
  error: { icon: ErrorIcon, title: 'Foutmelding', color: 'error.main' },
  success: { icon: CheckCircleIcon, title: 'Succes', color: 'success.main' },
  warning: { icon: WarningIcon, title: 'Waarschuwing', color: 'warning.main' },
  info: { icon: InfoIcon, title: 'Informatie', color: 'info.main' },
};

const ErrorPopup = ({ open, message, onClose, severity = 'error' }) => {
  const config = severityConfig[severity] || severityConfig.error;
  const IconComponent = config.icon;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ bgcolor: config.color, color: 'white' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconComponent />
          <Typography>{config.title}</Typography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Sluiten
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorPopup;
